import { render, staticRenderFns } from "./FormOutputLabel.vue?vue&type=template&id=1193245e&"
import script from "./FormOutputLabel.vue?vue&type=script&setup=true&lang=ts&"
export * from "./FormOutputLabel.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports